import React, { Fragment } from 'react';
import { useRoutes } from 'react-router-dom';
import routes from 'routes';
import { Helmet } from 'react-helmet';

function App() {
  const routing = useRoutes(routes);
  const sessionMd5Email = localStorage.getItem('md_email');

  return (
    <Fragment>
      {sessionMd5Email && (
        <Helmet>
          <script
            src={`${process.env.REACT_APP_SSO_CLIENT_URL}/sso-widget-v2?uid=${sessionMd5Email}&identifier=orderservice&host=${process.env.REACT_APP_APP_URL}`}
          ></script>
        </Helmet>
      )}
      {routing}
      <div id="sso-menu" />
    </Fragment>
  );
}

export default App;
